import { FacebookActionTypes } from "./FacebookActionTypes";

export const refreshSellerCompleted = () =>
  ({
    type: FacebookActionTypes.FACEBOOK_REFRESH_SELLER_COMPLETED,
  } as const);
